import {
	Divider,
	FormControl,
	Icon,
	IconButton,
	Menu,
	MenuItem,
	Select,
	Tooltip
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { replaceInTextHbr } from "helpers/utilities";
import { useEffect, useState } from "react";

const SELECT_COLOR = {
	waiting: "black",
	ongoing: "white",
	resolved: "white",
	canceled: "white"
};

const SELECT_BG_COLOR = {
	waiting: "light",
	ongoing: "info",
	resolved: "success",
	canceled: "error"
};

const Header = ({
	item = {},
	resource = {},
	onClose = () => {},
	performFrontAction = () => {},
	onChangeState = () => {},
	updateItem = () => {},
	actions = []
}) => {
	const [selectedState, setSelectedState] = useState("waiting");

	const headerInformations = replaceInTextHbr(resource?.format?.header, item, true);

	// State for MUI Menu
	const [menuAnchorEl, setMenuAnchorEl] = useState(null);
	const menuOpen = Boolean(menuAnchorEl);

	const renderAction = (actionCode, onClick) => {
		const action = actions.find(action => action.code === actionCode);
		if (!action) return null;

		return (
			<MenuItem
				onClick={() => {
					onClick(action);
				}}
			>
				<Icon fontSize="small">{action.icon}</Icon>&nbsp;{action.description}
			</MenuItem>
		);
	};

	const handleMenuOpen = event => {
		setMenuAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setMenuAnchorEl(null);
	};

	useEffect(() => {
		setSelectedState(item?.state || "waiting");
	}, [item]);

	return (
		<MDBox
			display="flex"
			flexDirection="row"
			justifyContent="space-between"
			alignItems="center"
			shadow="sm"
			p={1}
			sx={{
				width: "100%"
			}}
		>
			<MDBox>
				<MDTypography variant="h6" fontWeight="bold">
					{headerInformations?.title}
				</MDTypography>
				<MDTypography variant="caption" fontSize="small">
					{headerInformations?.description}
				</MDTypography>
			</MDBox>
			<MDBox display="flex" flexDirection="row" justifyContent="center" alignItems="stretch">
				{/* Assigned */}
				<MDBox
					sx={{
						border: "1px solid #e0e0e0",
						userSelect: "none",
						minWidth: 150
					}}
					mr={1}
					borderRadius="md"
					display="flex"
					alignItems="center"
					justifyContent="center"
					p={1}
				>
					<MDTypography variant="caption" fontSize="small" mr={1}>
						{item?.agent ?? "Non assigné"}
					</MDTypography>
				</MDBox>
				{/* State */}
				<MDBox bgColor={SELECT_BG_COLOR[selectedState]} sx={{ minWidth: 100 }} borderRadius="md">
					<FormControl fullWidth size="small">
						<Select
							labelId="select-label"
							id="select"
							value={selectedState}
							onChange={e => {
								setSelectedState(e.target.value);
								onChangeState(e.target.value);
							}}
							sx={{
								boxShadow: "none",
								".MuiOutlinedInput-notchedOutline": { border: 0 },
								"&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
									border: 0
								},
								"&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
									border: 0
								},
								".MuiSelect-icon": {
									display: "block",
									fill: SELECT_COLOR[selectedState]
								},
								".MuiSelect-select": {
									color: `${SELECT_COLOR[selectedState]} !important`,
									fontWeight: "bold"
								}
							}}
						>
							<MenuItem value="waiting">En attente</MenuItem>
							<MenuItem value="ongoing">En cours</MenuItem>
							<MenuItem value="resolved">Résolu</MenuItem>
							<MenuItem value="canceled">Annulé</MenuItem>
						</Select>
					</FormControl>
				</MDBox>
				{/* Actions */}
				<Tooltip title="Actions" arrow placement="top">
					<IconButton onClick={handleMenuOpen}>
						<Icon>apps</Icon>
					</IconButton>
				</Tooltip>
				<Menu
					anchorEl={menuAnchorEl}
					open={menuOpen}
					onClose={handleMenuClose}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center"
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "center"
					}}
				>
					{/* Assign conversation */}
					{renderAction("assignDocument", action => {
						handleMenuClose();
						performFrontAction(action, [item], resource, ({ success, result }) => {
							updateItem(result);
						});
					})}

					{renderAction("unassignDocument", action => {
						handleMenuClose();
						performFrontAction(action, [item], resource, ({ success, result }) => {
							updateItem(result);
						});
					})}

					{renderAction("generateCSVFile", action => {
						handleMenuClose();
						performFrontAction(action, [item], resource, ({ success, result }) => {});
					})}
				</Menu>
				{/* Close */}
				<Tooltip title="Fermer" arrow placement="top">
					<IconButton onClick={onClose}>
						<Icon>close</Icon>
					</IconButton>
				</Tooltip>
			</MDBox>
		</MDBox>
	);
};

export default Header;
